import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  pages: [
    {
      path: '/tenders/tenders',
      load: () => import('./tenders-page'),
      permission: 'tenders.tender.read',
    },
    {
      path: '/tenders/tenders/$id',
      load: () => import('./tender-page'),
      permission: 'tenders.tender.read',
    },
    {
      path: '/tenders/mine',
      load: () => import('./mine-page'),
      permission: 'tenders.tender.read',
    },
    {
      path: '/tenders/evidence',
      load: () => import('./evidence-page'),
      permission: 'tenders.evidence.read',
    },
    {
      path: '/tenders/evidence/$id',
      load: () => import('./evidence-detail-page'),
      permission: 'tenders.evidence.read',
    },
    {
      path: '/tenders/sources',
      load: () => import('./sources-page'),
      permission: 'tenders.settings.manage',
    },
  ],
  guides: [
    {
      id: 'tenders.tenders',
      title: 'tenders.guides.tenders.title',
      summary: 'tenders.guides.tenders.summary',
      pages: [
        '/tenders/tenders',
        '/tenders/tenders/$id',
        '/tenders/mine',
        '/tenders/evidence',
        '/tenders/evidence/$id',
        '/tenders/sources',
      ],
      content: {
        de: () => import('./guides/tenders.de.md?raw'),
        en: () => import('./guides/tenders.en.md?raw'),
      },
    },
  ],
});
